export default {
    /*
        GET 	/api/todos
    */
    getOfferTemplates: function (data) {
        let params = {};
        if (typeof data !== undefined) {
            params = {
                params: data,
            }
        }
        return axios.get('/api/offer-templates', params);
    },

    postAddNewOfferTemplate: function(offerTemplate) {
        return axios.post('/api/offer-templates',
            offerTemplate, {successHandle: true},
        );
    },
    postUpdateOfferTemplate: function(offerTemplate) {
        return axios.put('/api/offer-templates/' + offerTemplate.offerTemplate.id,
            offerTemplate, {successHandle: true},
        );
    },
}
